interface Currency {
  displayName: string;
  numericCode: number;
  defaultFractionDigits: number;
  subUnit: number;
  symbolSpaced: boolean;
  symbolPosition: "after" | "before";
  symbol: string;
  isoCode: "BAM";
};

const BAM: Currency = Object.freeze({
  "displayName": "Bosnia-Herzegovina Convertible Mark",
  "numericCode": 977,
  "defaultFractionDigits": 2,
  "subUnit": 100,
  "symbolSpaced": true,
  "symbolPosition": "after",
  "isoCode": "BAM",
  "symbol": "KM"
});

export { BAM };
